export default "__VITE_ASSET__B5G5QxsH__"